import React from 'react'
import AchieveHero from './AchieveHero'
import CelebrateExcellence from './CelebrateExcellence'
import DeepakJourney from './DeepakJourney'
import ExploreMoments from './ExploreMoments'
import WhyShare from './WhyShare'

const AchieveMentsPage = () => {
  return (
      <>
          <AchieveHero />
      <CelebrateExcellence />
      <DeepakJourney />
      <ExploreMoments />
      <WhyShare/>
      </>
  )
}

export default AchieveMentsPage